export const DEFAULT_ALLOWED_HTML_TAGS_FOR_ERROR_MESSAGES = ['br', 'a'];

export const DEFAULT_ALLOWED_HTML_TAG_ATTRIBUTES_FOR_ERROR_MESSAGES = {
  a: ['href'],
};
